<!-- src/components/InfoPage.vue -->
<template>
    <div class="info-page-container">
        <div class="info-content-wrapper">
            <!-- PC: ← Back -->
            <div class="breadcrumb breadcrumb-pc" @click="goBack">
                <span class="back-arrow">←</span>
                <span class="breadcrumb-text">Back</span>
            </div>
            <!-- H5: Home icon -->
            <div class="breadcrumb breadcrumb-h5" @click="goHome">
                <span class="home-icon-fallback">
                    <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                </span>
                <span class="breadcrumb-text">Home</span>
            </div>

            <div class="info-content-box">
                <component :is="currentComponent" />
            </div>
        </div>
    </div>
</template>

<script>
import ServiceFees from './info/ServiceFees.vue'
import ParticipationBenefits from './info/ParticipationBenefits.vue'
import ComplianceStandards from './info/ComplianceStandards.vue'
import PrivacyData from './info/PrivacyData.vue'
import LegalNotices from './info/LegalNotices.vue'

export default {
    name: 'InfoPage',
    components: {
        ServiceFees,
        ParticipationBenefits,
        ComplianceStandards,
        PrivacyData,
        LegalNotices
    },
    computed: {
        currentComponent() {
            const type = this.$route.params.type
            switch (type) {
                case 'service-fees':
                    return 'ServiceFees'
                case 'participation-benefits':
                    return 'ParticipationBenefits'
                case 'compliance-standards':
                    return 'ComplianceStandards'
                case 'privacy-data':
                    return 'PrivacyData'
                case 'legal-notices':
                    return 'LegalNotices'
                default:
                    return 'ServiceFees'
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        goHome() {
            this.$router.push('/')
        }
    }
}
</script>

<style scoped>
.info-page-container {
    min-height: calc(100vh - 300px);
    background-color: #fff;
    padding: 40px 10%;
}

.info-content-wrapper {
    width: 100%;
    max-width: 900px;
}

.breadcrumb {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 32px;
}

/* PC shows Back, H5 hidden */
.breadcrumb-pc {
    display: flex;
}
.breadcrumb-h5 {
    display: none;
}

.back-arrow {
    font-size: 20px;
    color: #333;
    margin-right: 10px;
    font-weight: 500;
}

.home-icon-fallback {
    display: flex;
    align-items: center;
    margin-right: 8px;
    color: #555;
}

.breadcrumb-text {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: rgba(108, 108, 120, 1);
}

.breadcrumb:hover .breadcrumb-text,
.breadcrumb:hover .back-arrow {
    color: #ff5e62;
}

.info-content-box {
    width: 100%;
}

@media (max-width: 900px) {
    .info-page-container {
        padding: 20px 16px;
        background-color: #fcfcfc;
    }
    .info-content-wrapper {
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
        padding: 20px 16px;
    }
    /* H5 shows Home, PC hidden */
    .breadcrumb-pc {
        display: none;
    }
    .breadcrumb-h5 {
        display: flex;
    }
    .breadcrumb {
        margin-bottom: 20px;
        cursor: default;
    }
    .breadcrumb-text {
        font-size: 14px;
        color: #555;
    }
}
</style>
